// Based on popular proposal for Math.clamp extension
// Spec: https://rwaldron.github.io/proposal-math-extensions/#sec-math.clamp
// Polyfill: https://github.com/zloirock/core-js/blob/master/packages/core-js/modules/esnext.math.clamp.js
export const clamp = (x, lower, upper) => {
  return Math.min(upper, Math.max(lower, x));
}
